import React from 'react'

const HeadlineCards = () => {
 return(
  <div className='bg-[#dbb42c] max-w-[1640px] mx-auto p-4 py-12 grid md:grid-cols-3 gap-6'>
     {/*card */}
       <div className='rounded-xl relative'>
        {/*overlay*/}
            <div className='absolute w-full h-full bg-black/40 rounded-xl text-white'>
             <p className='font-bold text-2xl px-2 pt-4'>Summer is over, Welcome Pumpkin Spice Specials</p>
             <p className='px-2'>Through October 31</p>
             <button className='border-white bg-white text-black mx-2 absolute bottom-4'>Order Now</button>

            </div>
            <img className='max-h-[160px] md:mx-h-[200px] w-full object-cover rounded-xl' src="https://images.pexels.com/photos/3151775/pexels-photo-3151775.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="/"/>
       </div>
       <div className='rounded-xl relative'>
        {/*overlay*/}
            <div className='absolute w-full h-full bg-black/40 rounded-xl text-white'>
             <p className='font-bold text-2xl px-2 pt-4'>New Shops</p>
             <p className='px-2'>Added Daily</p>
             <button className='border-white bg-white text-black mx-2 absolute bottom-4'>Order Now</button>

            </div>
            <img className='max-h-[160px] md:mx-h-[200px] w-full object-cover rounded-xl' src="https://images.pexels.com/photos/1162455/pexels-photo-1162455.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="/"/>
       </div>
       <div className='rounded-xl relative'>
        {/*overlay*/}
            <div className='absolute w-full h-full bg-black/40 rounded-xl text-white'>
             <p className='font-bold text-2xl px-2 pt-4'>We Deliver Pastries</p>
             <p className='px-2'>Tasty Snacks</p>
             <button className='border-white bg-white text-black mx-2 absolute bottom-4'>Order Now</button>

            </div>
            <img className='max-h-[160px] md:mx-h-[200px] w-full object-cover rounded-xl' src="https://images.pexels.com/photos/1397292/pexels-photo-1397292.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="/"/>
       </div>
  </div>
 )
}


export default HeadlineCards